import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function ThankYouPage() {
  useEffect(() => {
    // Update page title and meta tags
    document.title = 'Thank You - Cape Town Professional Painters | Quote Request Received';
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Thank you for your quote request. Cape Town painting contractors will contact you soon. Professional painting services across Cape Town and surrounding areas.');
    }

    // Update meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'thank you, quote request, Cape Town painters, painting contractors contact');
    }

    // Update canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/thank-you`);
    }

    // Google Analytics conversion tracking
    if (typeof gtag !== 'undefined') {
      gtag('event', 'ads_conversion_Form_1', {
        // <event_parameters>
      });
    }

    // Add Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Thank You - Cape Town Professional Painters",
      "description": "Thank you for your quote request. Cape Town painting contractors will contact you soon.",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/thank-you`
    });
    document.head.appendChild(script);

    return () => {
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript && existingScript.textContent?.includes('Thank You')) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Thank You Section */}
      <section className="py-32 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="bg-white rounded-3xl shadow-xl p-16 border border-gray-100">
            {/* Success Icon */}
            <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-8">
              <i className="ri-check-double-line text-4xl text-green-600"></i>
            </div>
            
            {/* Thank You Message */}
            <h1 className="text-5xl font-bold text-black mb-8">
              Thank you
            </h1>
            
            <p className="text-2xl text-gray-600 mb-12 leading-relaxed">
              The relevant painting contractors will be in contact ASAP.
            </p>
            
            {/* Social Media Section */}
            <div className="space-y-8">
              <div className="border-t border-gray-200 pt-8">
                <p className="text-lg text-gray-600 mb-6">
                  While you wait, connect with us on social media
                </p>
                
                <a
                  href="https://www.facebook.com/profile.php?id=100065136067057"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center space-x-3 bg-blue-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-facebook-fill text-2xl"></i>
                  <span>Like us on Facebook</span>
                </a>
              </div>
              
              {/* Powered by Section */}
              <div className="border-t border-gray-200 pt-8">
                <p className="text-gray-500 text-base">
                  <a 
                    href="https://leaderr.co/" 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-600 hover:text-black transition-colors cursor-pointer font-medium"
                  >
                    Powered by leaderr
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Additional Information */}
      <section className="py-16 bg-yellow-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-black mb-6">
            What Happens Next?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-6 shadow-sm">
              <div className="w-12 h-12 bg-yellow-400 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-xl text-black"></i>
              </div>
              <h3 className="text-xl font-semibold text-black mb-3">Quick Response</h3>
              <p className="text-gray-600">
                Qualified contractors will contact you within 24-48 hours
              </p>
            </div>
            
            <div className="bg-white rounded-xl p-6 shadow-sm">
              <div className="w-12 h-12 bg-yellow-400 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-file-list-3-line text-xl text-black"></i>
              </div>
              <h3 className="text-xl font-semibold text-black mb-3">Detailed Quotes</h3>
              <p className="text-gray-600">
                Receive up to 5 comprehensive quotes to compare
              </p>
            </div>
            
            <div className="bg-white rounded-xl p-6 shadow-sm">
              <div className="w-12 h-12 bg-yellow-400 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-star-line text-xl text-black"></i>
              </div>
              <h3 className="text-xl font-semibold text-black mb-3">Choose the Best</h3>
              <p className="text-gray-600">
                Select the contractor that best fits your needs and budget
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}